'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactJss = require('react-jss');

var _reactJss2 = _interopRequireDefault(_reactJss);

var _modal = require('./modal');

var _modal2 = _interopRequireDefault(_modal);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactJss2.default)(_styles2.default)(_modal2.default);


//////////////////
// WEBPACK FOOTER
// ./~/react-responsive-modal/lib/index.js
// module id = 113
// module chunks = 0